<div class="main-content__relative">
    <div class="padding-top content-grid mdl-grid confirmation-content">
        <div class="mdl-layout-spacer"></div>
        <div *ngIf="item" class="mdl-cell mdl-cell--9-col mdl-cell--12-col-phone confirmation">
            <!-- <img class="confirmation__bus" src="./assets/images/Icon_pop_up_desktop@2x.png" alt="Imagen bus"> -->
            <div class="confirmation--title">
                <h1>{{'CONFIRMATION_SUCCESS' | translate}}</h1>
                <h2>{{'CONFIRMATION_REVIEW' | translate}}</h2>
            </div>
            <div class="confirmation--container">
                <div class="confirmation--container__description" *ngFor="let sale of item?.sales">
                    <div class="confirmation--container__text">
                        <div class="confirmation__name">
                            <span>{{sale.productOption}}</span>
                        </div>
                        <div class="confirmation__pax">
                            <span class="confirmation__pax-person">
                                <ng-container *ngFor="let unit of sale.units; let isLast=last">
                                    {{unit.pax}} x {{unit.personType.name.toUpperCase() | translate}}
                                    <span *ngIf="unit.groupSize"> {{'UP_TO' | translate}} {{unit.groupSize}} {{'PEOPLE' | translate}}</span>{{isLast ? '' : ', '}}
                                </ng-container>
                            </span>
                            <span class="confirmation__pax-info">{{sale.bookingDateRequired ? sale.date+', '+sale.initTime : sale.date+' - '+('CONFIRMATION_VALID_3MONTHS' | translate)}}</span>
                        </div>
                        <div class="confirmation__voucher">
                            <div class="confirmation__voucher__icon">
                                <img *ngIf="sale.mobileAccess == false; else mobileVoucher" width="17px" height="25px" src="../../assets/images/paper_voucher.png" alt="Paper voucher">
                                <ng-template #mobileVoucher>
                                    <img src="../../assets/images/mobile_paper_voucher.png" alt="Mobile voucher" height="27px" width="22px">
                                </ng-template>
                            </div>
                            <div *ngIf="sale.mobileAccess == false; else mobileVoucherText" class="confirmation__voucher__text">
                                <p class="first_paragraph">{{ 'PAPER_VOUCHER' | translate }}</p>
                                <p class="second_paragraph">{{ 'REQUIRED' | translate }}</p>
                            </div>
                            <ng-template #mobileVoucherText>
                                <div class="confirmation__voucher__text">
                                    <p class="first_paragraph">{{ 'MOBILE_OPT' | translate }}
                                        <span class="second_span">{{ 'AND' | translate}}</span>
                                        <span class="first_paragraph">{{ 'PAPER' | translate }} </span>
                                    </p>
                                    <p class="second_paragraph">{{ 'VOUCHER_P' | translate }}</p>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="confirmation--container__space"></div>
                </div>
                <div class="confirmation--container__button">
                    <download-voucher [oldToken]="oldToken" *ngIf="!pending"></download-voucher>
                </div>
                <div class="confirmation--container__list">
                    <ul>
                        <li>
                            <span>
                                <i class="material-icons color-purple">check_circle</i>{{'CONFIRMATION_MAIL' | translate}}
                                <span class="text_weight" *ngFor="let email of item.emails; let isLast=last" >{{email}}{{isLast ? '' : ', '}}</span>
                            </span>
                        </li>
                        <li>
                            <span>
                                <i class="material-icons color-blue">check_circle</i>{{'CONFIRMATION_TITLE' | translate}}
                                <span class="text_red">{{item?.payment?.reference}}</span>
                            </span>
                        </li>
                        <li *ngIf="isMobileVoucher">
                            <span>
                                <i class="material-icons color-red">check_circle</i>{{'CONFIRMATION_ETICKET' | translate}}</span>
                        </li>
                        <li *ngIf="isPaperRequired">
                            <span><i class="material-icons color-red">check_circle</i>{{'CONFIRMATION_PRINT' | translate}}</span>
                        </li>
                        <li>
                            <span><i class="material-icons color-yellow">check_circle</i>{{'CONFIRMATION_HELP' | translate}}</span>
                            <span>{{'CONFIRMATION_CONTACT' | translate}} <a>info@cityexpert.travel</a></span>
                        </li>
                        <li>
                            <span>{{'CONFIRMATION_ENJOY' | translate}}</span>
                        </li>
                    </ul>
                </div>
                <!-- <div class="confirmation--container__newsletter">
                    <div class="confirmation__subscribe">
                        <h3>Suscribete a nuestra newsletter</h3>
                        <div class="confirmation__subscribe-box">
                            <span>Mantente al dia sobre nuestros nuevos destinos, promociones y mucho más</span>
                            <div class="subs-form">
                                <input class="subs-form__input" type="text">
                                <button class="subs-form__button">Suscribirse</button>
                            </div>
                        </div>
                    </div>
                    <div class="confirmation__rrss">
                        <h3>Siguenos en nuestras RRSS</h3>
                        <div class="confirmation__rrss-icons">
                            <div class="confirmation__rrss-background">
                                <i class="fa fa-twitter" aria-hidden="true"></i>
                            </div>
                            <div class="confirmation__rrss-background">
                                <i class="fa fa-facebook" aria-hidden="true"></i>
                            </div>
                            <div class="confirmation__rrss-background">
                                <i class="fa fa-instagram" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="confirmation--container__crosseling"></div> -->
            </div>
        </div>
        <!-- <img class="confirmation-content__color" src="./assets/images/confirm-colours2.png" alt="Colors"> -->
        <div class="mdl-layout-spacer"></div>
    </div>
    <div class="display-back" *ngIf="!quitDisplay" (click)="removeDisplay()">
        <div class="display-back__container">
            <div class="display-back__container-head">
                <span>{{'CONFIRMATION_CONGRATS' | translate}}</span>
            </div>
            <div class="display-back__container-body">
                <img src="./assets/images/Icon_pop_up_desktop@2x.png" alt="City expert logo">
                <span>{{'CONFIRMATION_SUCCESS' | translate}}</span>
            </div>
        </div>
        <!-- <img class="display-back__color" src="./assets/images/confirm-colours2.png" alt="Colors"> -->
    </div>
</div>
